import PositionDetail from './PositionDetail';

export default PositionDetail;
